// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__38wcH","Label":"BuildControl_Label__2Yf7n","Less":"BuildControl_Less__tDaWe","More":"BuildControl_More__1MCXM"};